'use client';

import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { User, getStoredUser, storeUser, clearUser } from './auth';

interface AuthContextType {
  user: User | null;
  setUser: (user: User | null) => void;
  logout: () => void;
  isAdmin: boolean;
}

const AuthContext = createContext<AuthContextType>({
  user: null,
  setUser: () => {},
  logout: () => {},
  isAdmin: false,
});

export function AuthProvider({ children }: { children: ReactNode }) {
  const [user, setUserState] = useState<User | null>(null);

  useEffect(() => {
    const stored = getStoredUser();
    if (stored) setUserState(stored);
  }, []);

  const setUser = (u: User | null) => {
    setUserState(u);
    if (u) storeUser(u);
    else clearUser();
  };

  const logout = () => {
    clearUser();
    setUserState(null);
    window.location.href = '/sign-up-login-screen';
  };

  return (
    <AuthContext.Provider value={{ user, setUser, logout, isAdmin: user?.role === 'admin' }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
